import { reactive } from 'sitekit-extensions'
import on from '../util/elements/on'
import destroys from '../util/elements/destroys'

export default function (Site, $) {
  let menu

  function getWidget (el) {
    return Site.getAllWidgets(el)[0]
  }

  Site.widget('main-menu', {
    use: [reactive()],
    _create () {
      destroys(this)
      this.featuredImagesWrapper = $('.menu-featured-image')
      this.featuredImages = this.featuredImagesWrapper.find('[data-id]')
      this.keys = this.element.find('[data-primary-id]')

      const el = this.featuredImagesWrapper
        .find('[data-home-image]')
        .css({ opacity: '', display: '' })

      this.homeImg = el
        .parent()
        .eq(0)
        .get(0)

      this.state = {
        open: false,
        submenu: '',
        focus: el.attr('data-id')
      }

      menu = this

      this.destroys(
        on(this.keys, 'mouseover', e => {
          this.setState({ focus: $(e.currentTarget).attr('data-primary-id') })
        }),
        on(window, 'click', e => {
          if (this.wasClicked) {
            this.wasClicked = false
            return
          }
          if (this.state.submenu) {
            return this.setState({ submenu: '' })
          }
          this.setState({ open: false })
        }),
        on(this.element, 'click', e => {
          this.wasClicked = true
        })
      )
    },
    xhrPageWillLoad () {
      this.setState({ submenu: '', open: false })
    },
    updateImages () {
      this.featuredImages.each((i, el) => {
        const $el = $(el)
        const id = $el.attr('data-id')

        const isIn = this.state.submenu
          ? id == this.state.submenu
          : id == this.state.focus

        if (isIn) {
          $el.css({ opacity: '', display: '' })
          const widget = getWidget($el.parent().get(0))
          widget && widget.init()
        }
        $el.css({ opacity: isIn ? '' : 0 })
      })
    },
    react () {
      this.changed('focus', () => {
        this.updateImages()
      })
      this.changed('open', () => {
        if (!this.hasOpened && this.state.open) {
          this.hasOpened = true
          getWidget(this.homeImg).init()
        }

        // if (!this.state.open) this.setState({submenu: ''})

        this.element.toggleClass('open', this.state.open)
        this.featuredImagesWrapper.toggleClass('open', this.state.open)
        $(document.body).toggleClass('navopen', this.state.open)
      })

      this.changed('submenu', () => {
        this.element.find(`[data-id].open`).removeClass('open')
        this.updateImages()

        if (this.state.submenu) {
          this.element
            .find(`[data-id="${this.state.submenu}"]`)
            .addClass('open')
        }
      })
    }
  })

  Site.widget('menu-toggle', {
    _create () {
      destroys(this)
      const span = this.element.find('span.toggle-text')
      this.destroys(
        on(this.element, 'click', e => {
          e.preventDefault()
          e.stopPropagation()

          menu.setState({ open: !menu.state.open })
        }),
        menu.changed('open', () => {
          this.element.toggleClass('open', menu.state.open)
          span.text(menu.state.open ? 'Close' : 'Menu')
        })
      )
    }
  })

  Site.widget('submenu-toggle', {
    _create () {
      destroys(this)
      const key = this.options.key
      const a = this.element.find('a')

      this.destroys(
        on(a, 'click', e => {
          const isActive = menu.state.submenu === key
          if (isActive) return

          e.preventDefault()
          e.stopPropagation()
          menu.setState({ submenu: key })
        })
      )
    }
  })

  Site.widget('sticky-header', {
    _create () {
      this.stickyHeader()
    },

    stickyHeader () {
      on(
        $(window),
        'scroll',
        () => {
          if (window.scrollY > 130) {
            $('body').addClass('header-st')
          } else {
            $('body').removeClass('header-st')
          }
        }
      )
    }
  })

  Site.widget('sticky-search', {
    _create () {
      this.stickySearch()
    },

    stickySearch () {
      this.element.find('.search-toggle').on('click', () => {
        $('body').removeClass('search-st')
      })

      $('.icon.search-link, .new-search').on('click', () => {
        $('body').addClass('search-st')
      })
    }
  })
}
